import { render, staticRenderFns } from "./AllHeader.vue?vue&type=template&id=922b0ca2&scoped=true"
import script from "./AllHeader.vue?vue&type=script&lang=js"
export * from "./AllHeader.vue?vue&type=script&lang=js"
import style0 from "./AllHeader.vue?vue&type=style&index=0&id=922b0ca2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922b0ca2",
  null
  
)

export default component.exports